export enum SendOtpHttpStatusEnum {
    OTP_SENT_SUCESSFULLY = '200',
    OTP_SENT_SUCESSFULLY_HOUSING_CLIENT = '207',
    BLOCKED_BY_SECURITY_DAYS = '403',
    BLOCKED_BY_SECURITY_MONTHS = '417',
    BLOCKED_BY_SECURITY_IP = '412',
    BLOCKED_BY_IP_INQUIRY = '429',
    BLOCKED_PHONE_BY_MANY_USERS = '409',
    BLOCKED_PHONE_BY_REEXPEDITION = '423',
    BLOCKED_INVALID_IDENTIFICATION_NUMBER = '451',
}



// WEBPACK FOOTER //
// ./src/app/bdb-one-time-password/validate-otp/send-otp-http-status.enum.ts